module.exports = __webpack_public_path__ + "img/image_core04@2x.b5478886.png";